import React from 'react';
import { Platform, View } from 'react-native';
import useChatScrollbarInset from '@/hooks/useChatScrollbarInset';

const ChatComposerOverlay = React.forwardRef(function ChatComposerOverlay({
  getScrollElement, showsScrollIndicator, conversationId, ready,
  sourcesReservedRight = 0, showBrowserPanel = false, style, ...props
}, ref) {
  const scrollbarInset = useChatScrollbarInset(getScrollElement, showsScrollIndicator, conversationId, ready);
  return <View {...props} ref={ref} testID="chat-composer-overlay" style={[
    style,
    (sourcesReservedRight > 0 || scrollbarInset > 0) && { right: sourcesReservedRight + scrollbarInset, width: 'auto' },
    showBrowserPanel && { right: Platform.OS === 'web' ? `calc(55% + ${scrollbarInset}px)` : '55%', width: 'auto' },
  ]} />;
});

export default ChatComposerOverlay;
